(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hot-main-stage-heading"] && !Shopify.designMode) return;
  try {
    // Widen the wordmark to one line when the banner has room, and move the
  // sparks to fresh letters on each glow cycle, without a separate timer.
  class HotMainStageWordmark extends HTMLElement {
    connectedCallback() {
      this.wordmark = this.querySelector('svg.hot-mainstage-wordmark');
      if (!this.wordmark) return;

      this.lettering = this.wordmark.querySelector('#hot-mainstage-lettering');
      this.letters = [...this.lettering.querySelectorAll('path')];
      this.sparks = [...this.wordmark.querySelectorAll('.title-spark')];
      this.face = this.wordmark.querySelector('.letter-face');
      this.wideLayout = matchMedia('(min-width: 750px)');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

      this.face.addEventListener('animationiteration', this.onIteration);
      this.wideLayout.addEventListener('change', this.updateLayout);
      this.reducedMotion.addEventListener('change', this.placeSparks);
      this.updateLayout();
    }

    disconnectedCallback() {
      if (!this.wordmark) return;
      this.face.removeEventListener('animationiteration', this.onIteration);
      this.wideLayout.removeEventListener('change', this.updateLayout);
      this.reducedMotion.removeEventListener('change', this.placeSparks);
    }

    onIteration = (event) => {
      if (event.animationName === 'hot-mainstage-face-lighten') this.placeSparks();
    };

    placeSparks = () => {
      if (this.reducedMotion.matches) return;

      // Pick different letters within each burst so sparks never pile up.
      const shuffled = [...this.letters];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }

      const viewport = this.wordmark.viewBox.baseVal;
      const ctm = this.wordmark.getCTM();
      if (!ctm) return;
      const toViewBox = ctm.inverse();
      this.sparks.forEach((spark, i) => {
        const letter = shuffled[i];
        const transform = toViewBox.multiply(letter.getCTM());
        const length = letter.getTotalLength();
        let point;
        // Leave room for each sparkle and its glow inside the SVG edges.
        for (let attempt = 0; attempt < 32; attempt++) {
          point = letter.getPointAtLength(Math.random() * length).matrixTransform(transform);
          if (point.x >= 16 && point.x <= viewport.width - 16 &&
              point.y >= 16 && point.y <= viewport.height - 16) break;
        }
        const x = Math.max(16, Math.min(viewport.width - 16, point.x));
        const y = Math.max(16, Math.min(viewport.height - 16, point.y));
        const scale = 0.7 + Math.random() * 0.3;
        spark.parentElement.setAttribute('transform',
          `translate(${x.toFixed(2)} ${y.toFixed(2)}) scale(${scale.toFixed(2)})`);
      });
    };

    updateLayout = () => {
      const wide = this.wideLayout.matches;
      const wordmark = this.wordmark;
      wordmark.dataset.layout = wide ? 'wide' : 'stacked';
      wordmark.setAttribute('viewBox', wide ? '0 0 740 146' : '0 0 400 234');
      wordmark.setAttribute('width', wide ? '740' : '400');
      wordmark.setAttribute('height', wide ? '146' : '234');
      this.lettering.setAttribute('transform', wide ? 'translate(26 10) skewX(-9)' : 'translate(40 12) skewX(-9)');
      wordmark.querySelector('.hot-mainstage-stage-letters').setAttribute('transform',
        wide ? 'translate(354 0) scale(.88 .94)' : 'translate(0 87) scale(.88 .94)');
      wordmark.querySelector('.hot-mainstage-underline').setAttribute('d',
        wide ? 'M13 106H720L715 138H8Z' : 'M13 194H352L347 226H8Z');
      const label = wordmark.querySelector('.hot-mainstage-collection-label');
      label.setAttribute('x', wide ? '364' : '180');
      label.setAttribute('y', wide ? '122' : '210');
      this.placeSparks();
    };
  }

  if (!customElements.get('hot-main-stage-wordmark')) {
    customElements.define('hot-main-stage-wordmark', HotMainStageWordmark);
  }
  } catch(e) { console.error(e); }
})();

})();
